import {
  RETURN_TO_PROVISION,
  FETCH_RTP_DATA_SUCCESS,
  FETCH_RTP_DATA_FAILURE,
  UPLOAD_RTP_DATA,
  UPLOAD_RTP_DATA_SUCCESS,
  UPLOAD_RTP_DATA_FAILURE,
} from './types';

import initialState from './initialState';

function returnToProvisionReducer(state = initialState, action) {
  switch (action.type) {
    case RETURN_TO_PROVISION:
      return {
        ...state,
        returnToProvisionLoading: true,
      };
    case FETCH_RTP_DATA_SUCCESS:
      return {
        ...state,
        rtpDetails: action.rtpData,
        rtpDetailsError: null,
        returnToProvisionLoading: false,
      };
    case FETCH_RTP_DATA_FAILURE:
      return {
        ...state,
        rtpDetails: {},
        rtpDetailsError: action.error,
        returnToProvisionLoading: false,
      };
    case UPLOAD_RTP_DATA:
      return {
        ...state,
        uploadResponse: null,
      };
    case UPLOAD_RTP_DATA_SUCCESS:
      return {
        ...state,
        uploadResponse: 'Successful Upload',
      };
    case UPLOAD_RTP_DATA_FAILURE:
      return {
        ...state,
        uploadResponse: 'Upload Failure',
      };
    default:
      return state;
  }
}

export default returnToProvisionReducer;
